<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="share-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-share"></div>

                    <p class="share-info">{{ text }}</p>

                    <div class="u-btn share copy" data-clipboard-action="copy" :data-clipboard-text="text" @click="copy"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data : function () {
        return {
            evt_info : {},
            ua : {},
            visible : false,
            text : '',
        }
    },
    created (){
        //this.render();
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy (){
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功")
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败")
            });                           
        },
    }    
}
</script>

<style scoped>

    .u-btn.close{
        top: 25px;
        right: 40px;
        width: 32px;
        height: 34px;
        background-image: url(~@/assets/images/pc/vote/btn-close.png);
    }

    .share-modal{
        width: 654px;
        height: 368px;
        background-image: url(~@/assets/images/pc/bg-modal-share.png);
        font-size: 24px;
        color: #3f2a0e;
    }

    .t-share{
        width: 626px;
        height: 47px;
        margin: 0 auto 5px;
        background-image: url(~@/assets/images/pc/title-share.png);
    }

    .share-info{
        margin: 20px 80px;
        line-height: 1.8;
        color: #f6f4e6;
        font-size: 20px;
    }

    .u-btn.share{
        position: absolute;
        left: 50%;
        bottom: 30px;
        width: 214px;
        height: 51px;
        transform: translateX(-50%);
        background-image: url(~@/assets/images/pc/btn-ok.png);    
    }    

    .notice{
        text-align: center;
        color: #9d6f36;
    }
</style>


// WEBPACK FOOTER //
// src/components/ShareModal/shareModal.vue